import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {OrganizationEmail} from '../organization/organization-email';
import {GoogleService} from './google-service';

@Service()
export class OrganizationEmailService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getOrganizationEmails(organizationId: string): Observable<OrganizationEmail[]> {
    let url = this.urlBase + 'emails/organization/' + organizationId;
    return this.http.get<OrganizationEmail[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public deleteEmail(email: OrganizationEmail): Observable<string> {
    let url = this.urlBase + 'emails/' + email.orgUnitId + "/" + email.emailAddress;
    return this.http.delete(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  public save(email: OrganizationEmail): Observable<string> {
    let url = this.urlBase + 'emails/save';
    let body = JSON.stringify(email);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

}
